module.exports = __webpack_public_path__ + "assets/svg/UI/location-gray-a91807.svg";